import { Box, Typography } from "@mui/material";
import logo from "../assets/logo_black.png";
import { retrieveFromLocal } from "../helper/localStore";
import { IconButton, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

const TopBar = () => {
  const user: any = retrieveFromLocal("user");

  return (
    <Box
      sx={{ bgcolor: "#f8f8f8", px: 2 }}
      width={"100%"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Box
        width={150}
        height={90}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        px={5}
        py={2}
      >
        <img src={logo} alt="logo" height={"60%"} />
      </Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        gap={3}
      >
        {user && <Typography variant="h6">{user.name}</Typography>}
        <Tooltip title="Logout">
          <IconButton
            onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              window.location.reload();
            }}
          >
            <LogoutIcon color="error" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
export default TopBar;
